import { render } from "./MainInformation.vue?vue&type=template&id=36e55c82&scoped=true"
import script from "./MainInformation.vue?vue&type=script&lang=js"
export * from "./MainInformation.vue?vue&type=script&lang=js"

import "./MainInformation.vue?vue&type=style&index=0&id=36e55c82&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e55c82"]])

export default __exports__